import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { drivetrainById, isFlipped, styleText } from "@/rc/drivetrains";
import { attachmentSummary } from "@/rc/attachments";
import { RobotDiagram } from "./RobotDiagram";

const Row = ({ label, children, testId }) => (
  <div className="grid gap-1 px-4 py-3 sm:grid-cols-[120px_1fr]" data-testid={testId}>
    <dt className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</dt>
    <dd className="text-sm">{children}</dd>
  </div>
);

export const ReviewStep = ({ cfg, askName, name, onName }) => {
  const dt = drivetrainById(cfg.drivetrain);
  return (
    <div className="grid gap-6 lg:grid-cols-[280px_1fr]" data-testid="rc-review-step">
      <div className="grid-bg self-start rounded-2xl border bg-muted/30 p-7">
        <RobotDiagram dt={dt} cfg={cfg} mode="ports" live className="mx-auto w-full max-w-[210px]" />
      </div>
      <div className="space-y-5">
        {askName && (
          <div className="space-y-2">
            <Label htmlFor="rc-project-name">Project name</Label>
            <Input id="rc-project-name" value={name} onChange={(e) => onName(e.target.value)} maxLength={80} className="rounded-xl" data-testid="rc-project-name-input" />
          </div>
        )}
        <dl className="divide-y rounded-2xl border bg-card">
          <Row label="Drivetrain" testId="rc-review-drivetrain">{dt.name} <span className="text-muted-foreground">({dt.subtitle})</span></Row>
          <Row label="Motors" testId="rc-review-motors">
            <ul className="space-y-0.5">
              {dt.motors.map((m) => (
                <li key={m.id}>{m.label}: port <b>{cfg.motors[m.id].port}</b>{isFlipped(m, cfg.motors[m.id].dir) && <span className="text-[hsl(var(--rc-hot))]"> (reversed)</span>}</li>
              ))}
            </ul>
          </Row>
          {dt.kind === "car" && <Row label="Steering" testId="rc-review-steering">Up to {cfg.steerMax}° each way, back to straight when you let go</Row>}
          <Row label="Controls" testId="rc-review-controls">{styleText(cfg.style, dt.kind).name}</Row>
          <Row label="Attachments" testId="rc-review-attachments">
            {cfg.attachments?.length ? (
              <ul className="space-y-0.5">{cfg.attachments.map((a, i) => <li key={i}>{attachmentSummary(a)}</li>)}</ul>
            ) : <span className="text-muted-foreground">None</span>}
          </Row>
        </dl>
        <div className="rounded-2xl bg-secondary p-4 text-sm text-secondary-foreground">
          <p className="font-semibold">What happens next</p>
          <p className="mt-1">Connect your hub and press <b>Drive</b>. HubPilot sends this setup to the hub and starts it. Switch on your controller and drive. Once it's running you can close the laptop.</p>
        </div>
      </div>
    </div>
  );
};
